export default "<div class=\"content\" ng-transclude></div> <a class=\"close\" href ng-click=\"vm.close()\"><i class=\"icons icon-thin-x\"></i></a> ";